import groq from 'groq';
import sanityRequest from '@/sanity/requests/base';
import { getImageAttributes, slugToLink } from '@/sanity';
import { StoryListing } from '@/types';
import { SanityImageObject } from '@sanity/image-url/lib/types/types';

const query = groq`*[ _type == "story"][] {
  _id,
  title,
  titleTop,
  titleBottom,
  "slug": slug.current,
  publishedDate,
  hero {
    "desktop": desktopImage,
    "mobile": mobileImage,
    attribution,
    lightText,
  }
} | order(publishedDate desc)`;

export default function getStories() {
  const { sanity, store, loading, data, setData } = sanityRequest<
    StoryListing[]
  >();

  // const loading = ref(true);
  // const data = ref<StoryListing[] | undefined>(undefined);

  const stories = store.state.archiveStories.map(
    (id) => store.state.stories[id]
  );
  if (stories.length) {
    setData(stories);
  } else {
    sanity.client
      .fetch<Omit<StoryListing<SanityImageObject>, 'link'>[]>(query)
      .then((response) => {
        const stories = response.map((s, i) => {
          const { attribution, lightText } = s.hero;
          const story = {
            ...s,
            link: slugToLink('story', s.slug),
            hero: {
              desktop: getImageAttributes(
                s.hero.desktop,
                1000,
                i === 0 ? [1280, 1920, 2560] : undefined // First story uses a full width image
              ),
              mobile: getImageAttributes(s.hero.mobile),
              attribution,
              lightText,
            },
          } as StoryListing;
          store.commit.setStory(story);
          return story;
        });
        store.commit.setArchiveStories(stories.map((s) => s.slug));
        setData(
          store.state.archiveStories.map((id) => store.state.stories[id])
        );
      });
  }

  return { data, loading };
}
